$(function() {
    var $backTop = $('.backtop');

    if(!$backTop.length) return
    
    $backTop.on('click', function(e) {

        $('html, body').animate({
            scrollTop: $('body').offset().top
        }, 600);
    });
});



document.addEventListener('DOMContentLoaded', () => {
  const tabs = document.querySelectorAll('.tabs-nav li');
  const panes = document.querySelectorAll('.tab-pane');

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      // Remover "active" de todos
      tabs.forEach(t => t.classList.remove('active'));
      panes.forEach(p => p.classList.remove('active'));

      // Adicionar "active" na clicada
      tab.classList.add('active');
      document.getElementById(tab.dataset.tab).classList.add('active');
    });
  });
});
